export function sortDescendingFromNewest<
  T extends { createdAt?: number; creationDateTime?: number },
>(a: T, b: T) {
  if (a?.createdAt && b?.createdAt) {
    return b.createdAt - a.createdAt;
  }
  if (a.creationDateTime && b.creationDateTime) {
    return b.creationDateTime - a.creationDateTime;
  }
  return 0;
}
